import { Controller } from "@hotwired/stimulus"
import L from "leaflet"
import { tileUrl } from "../utils/map_tiles"

// Static mini-map for the front-page teaser: real coastlines behind the story
// dots, because a dot plot on a bare graticule has nothing to read against.
//
// Deliberately inert - every interaction handler is off and the container is
// pointer-events: none in CSS, so the whole card stays one link to the map
// page. Nothing here is a scaled-down wire-map: no rail, no tour, no popups,
// no fetch (the points come in as a value, already rendered by the server).
export default class extends Controller {
  static targets = ["canvas"]
  static values = { points: Array }

  connect() {
    if (!this.hasCanvasTarget || this.pointsValue.length === 0) return

    this._map = L.map(this.canvasTarget, {
      zoomControl: false,
      attributionControl: false,
      dragging: false,
      touchZoom: false,
      doubleClickZoom: false,
      scrollWheelZoom: false,
      boxZoom: false,
      keyboard: false,
      tap: false,
      fadeAnimation: false,
      zoomAnimation: false
    })
    // A view has to exist before anything else touches the map: invalidateSize
    // below asks for the centre, and on a view-less map that throws - which
    // silently swallowed the fitBounds and left the whole thing blank.
    this._map.setView([20, 0], 1)
    L.tileLayer(tileUrl(), { maxZoom: 8 }).addTo(this._map)

    const bounds = []
    this.pointsValue.forEach(([lat, lng]) => {
      if (lat == null || lng == null) return

      bounds.push([lat, lng])
      L.circleMarker([lat, lng], {
        radius: 3.5,
        weight: 1,
        color: "#fff",
        fillColor: "#b4232a",
        fillOpacity: 0.9,
        interactive: false
      }).addTo(this._map)
    })

    // Same deferral as the full map: fitting against a container the page has
    // not laid out yet clamps to maxZoom and strands the view.
    requestAnimationFrame(() => {
      this._map.invalidateSize()
      if (bounds.length > 0) this._map.fitBounds(bounds, { padding: [12, 12], maxZoom: 4 })
    })
  }

  disconnect() {
    if (this._map) {
      this._map.remove()
      this._map = null
    }
  }
}
